"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
function Label(_a) {
    var label = _a.label, isToggleable = _a.isToggleable, onClick = _a.onClick, isSeriesHidden = _a.isSeriesHidden;
    var labelClassNames = classnames_1.default('echLegendItem__label', {
        'echLegendItem__label--clickable': Boolean(onClick),
    });
    return isToggleable ? (react_1.default.createElement("button", { type: "button", className: labelClassNames, title: label, onClick: onClick, "aria-label": isSeriesHidden ? label + "; Activate to show series in graph" : label + "; Activate to hide series in graph" }, label)) : (react_1.default.createElement("div", { className: labelClassNames, title: label, onClick: onClick }, label));
}
exports.Label = Label;
//# sourceMappingURL=label.js.map